export default __webpack_public_path__ + "images/1F.27b6cba.png";